import { useEffect } from "react";
import { trackContact } from "../lib/fbpixel";

// Global click delegate: fires a Meta Pixel "Contact" event whenever a user
// clicks a `tel:` or `mailto:` link anywhere in the app. Mounted once at the
// shell level so we don't need to wrap every CTA individually.
export default function PixelContactTracker() {
  useEffect(() => {
    const handler = (e) => {
      const anchor = e.target.closest && e.target.closest("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        trackContact({ method: "phone", href });
      } else if (href.startsWith("mailto:")) {
        trackContact({ method: "email", href });
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return null;
}
